import styled from "styled-components";

const MainTextStyle = styled.p`
  color: white;
`;

export default function PrivacyPolicy() {
  return (
    <MainTextStyle>
      <h1>Terms of Use</h1>
      <h2> 1. Acceptance of Terms</h2>
      By using or visiting a ECRanked website (the "Website"), you agree to
      these terms and conditions (the "Terms"). ECRanked may, in its sole
      discretion, revise these Terms at any time without advance notice to you.
      You are bound by such revisions by continuing to use or visit the Website
      after they are posted online.
      <h2>2. ECRanked</h2>
      These Terms apply to all users of the Website, including users who
      contribute content to the Website. The Website may contain interactive
      areas designed to allow you to post content on the Website and/or comment.
      The use of these features is additionally governed by the "Code of
      Conduct" (defined below). The Website may contain links to third party
      websites that are not owned or controlled by ECRanked . The links to the
      third party websites are provided for your convenience, and the inclusion
      of the links does not imply approval or endorsement of the third party
      websites by ECRanked. ECRanked has no control over, and assumes no
      responsibility for, the content, privacy policies, or practices of any
      third party websites.
      <h2>3. User Accounts</h2>
      To access some features of the Website, you may have to register for a
      ECRanked user account. When registering for your user account, you must
      provide accurate and complete information. You are solely responsible for
      the activity that occurs on your user account, and you must keep your
      account password secure. You must notify ECRanked immediately of any
      breach of security or unauthorized use of your user account. Although
      ECRanked will not be liable for your losses caused by any unauthorized use
      of your user account, you may be liable for the losses of ECRanked or
      others due to such unauthorized use. You are at least 13 years old. There
      is no exception to this requirement. In addition, you acknowledge and
      follow your headset's regulations. For example: Oculus Terms of Use, Vive
      Terms of Use, Pimax Terms of Use, Valve Index Terms of Use, HP Reverb
      Terms of Use. You acknowledge and follow Discord Terms of Use. You
      acknowledge and follow the game ratings of the game(s) you play in Echo
      Combat. You have verified for any additional regional regulations, to play
      Virtual Reality games, based on your location.
      <h2>4. Ownership of Website Content </h2>
      As between you and the Website, ECRanked owns all intellectual property
      rights, including without limitation copyright and trade-mark rights, in
      all materials on or comprising the Website ("Content"), including, without
      limitation, all written, audio visual or other materials and graphical
      elements on the Website, but excluding "User Content" (defined below).
      ECRanked grants you a limited license to use, download, print, or
      reproduce in whole or in part, the Content on this Website, subject to the
      following conditions: they must be used or reproduced accurately, without
      any modification; they must identify ECRanked as the source; they must be
      used solely for non-commercial purposes; ECRanked's express, prior,
      written permission is required for any Content that is not included in the
      license above, such as any graphical elements or website code, and/or for
      the use of Content for any purpose not expressly permitted above, such as
      for any commercial purpose whatsoever. The ECRanked logos are trade-marks
      of ECRanked, and may not be used without the express written permission of
      ECRanked.
      <h2>5. User Content & Privacy Policy </h2>
      You may be able to post or upload (in designated areas of the Website)
      written content or other content (collectively "User Content") to the
      Website. You are solely responsible for your own User Content and the
      consequences of posting or publishing it. By uploading or posting User
      Content to the Website, you automatically grant ECRanked a worldwide,
      non-exclusive, royalty free, license to use, reproduce, modify, translate
      into different languages or formats, and publish such User Content on the
      Website for the purpose of sharing the User Content with users and
      visitors of the Website and to promote the Website. You represent and
      warrant that you own or have the rights to use the User Content and you
      license ECRanked to use the User Content in the manner contemplated by the
      Website and these Terms. ECRanked will not share or sell your personal
      information to any third parties. ECRanked is not responsible if you
      upload any form of media without full copyrights and ECRanked reserves the
      rights to delete such media at anytime. When creating an account, we
      collect your login credentials. We may also collect, when provided, your
      streaming url, your public Discord user identifier and your country flag.
      For the user experience, we also collect your timezone. We do not
      knowingly collect or solicit personally identifiable information from
      children under 13; if you are a child under 13, please do not attempt to
      register on the Website or send any personal information about yourself to
      us.
      <h2>6. Code of Conduct </h2>
      You may not use the ECRanked Website for any illegal or unauthorized
      purpose. In addition to the laws of The United States Of America, you also
      agree to comply with all local laws that apply to your use of the Website.
      You may not use the Website in any manner which could disable, overburden,
      damage, or impair the Website, ECRanked's servers or computer network, or
      interfere with any other party's use and enjoyment of the Website. You
      agree that you are responsible for your own conduct and communications
      while using the Website and for any consequences of that use. By way of
      example, and not as a limitation, you agree that when using the Website,
      you will not: post or upload any inappropriate, promotional, defamatory,
      destructive, obscene, or unlawful content; defame, abuse, harass, stalk,
      threaten or otherwise violate the legal rights (such as rights of privacy
      and publicity) of others; post or upload any User Content that infringes
      any patent, trademark, copyright, trade secret or other intellectual
      property right of any party; impersonate another person, or falsify or
      delete any author attributions, legal or other proper notices or
      proprietary designations or labels of the origin or source of any content;
      use the Website in connection with surveys, contests, junk email, spamming
      or any duplicative messages (commercial or otherwise); use any robot,
      spider, site search/retrieval application, or other device to retrieve or
      index any portion of the Website to collect information about other users
      or domain names; upload files that contain bugs, viruses, trojan horses,
      worms, or any other similar software or programs that may damage the
      operation of the computer or property of another; or submit User Content
      that falsely expresses or implies that such User Content is sponsored or
      endorsed by any party where it is not sponsored or endorsed by such party.
      While ECRanked prohibits such conduct and User Content in connection with
      the Website, you understand and agree that nonetheless you may be exposed
      to such conduct or User Content and that you use the Website at your own
      risk. ECRanked reserves the right to monitor use of this Website to
      determine compliance with these Terms. Although ECRanked does not read,
      review, vet or otherwise assess User Content in advance of its posting,
      ECRanked reserves the right to remove any User Content and/or terminate
      your ECRanked User Account without notice for breach or for any other
      reason.
      <h2>7. Miscellaneous </h2>
      You affirm that you are either more than 18 years of age, or possess
      parental or guardian consent to agree to these Terms and access and use
      the Website, and are otherwise fully able and competent to enter into the
      terms, conditions, obligations, affirmations, representations, and
      warranties set forth in these Terms, and to abide by and comply with these
      Terms. These Terms will be governed by and construed in accordance with
      the laws of the United States of America without giving effect to its
      conflict of laws provisions. You agree to submit to the personal and
      exclusive jurisdiction of the courts located in the United States of
      America . You may not assign these Terms or assign any rights or delegate
      any obligations under these Terms, in whole or in part, whether
      voluntarily or by operation of law, without our prior written consent.
      These Terms constitute the entire agreement between you and ECRanked with
      respect to the subject matter and supersede and replace all prior or
      contemporaneous understandings or agreements, written or oral, regarding
      such subject matter. If for any reason a court of competent jurisdiction
      finds any provision or portion of the Terms to be unenforceable, the
      remaining provisions of the Terms will continue in full force and effect.
      <h2>8. DISCLAIMER </h2>
      YOUR USE OF THIS WEBSITE IS ENTIRELY AT YOUR OWN RISK. THE WEBSITE AND
      CONTENT IS PROVIDED "AS IS" AND WITHOUT WARRANTIES OR CONDITIONS OF ANY
      KIND, EITHER EXPRESSED OR IMPLIED, INCLUDING ANY IMPLIED WARRANTIES OF
      MERCHANTABILITY, MERCHANTABLE QUALITY, FITNESS FOR A PARTICULAR PURPOSE,
      TITLE, OR NON-INFRINGEMENT. ECRANKED DOES NOT WARRANT THAT THE WEBSITE OR
      CONTENT CONTAINED IN THIS WEBSITE WILL BE UNINTERRUPTED OR ERROR-FREE,
      THAT DEFECTS WILL BE CORRECTED, OR THAT THIS WEBSITE OR THE SERVER THAT
      MAKES IT AVAILABLE ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS.
      WITHOUT LIMITING THE FOREGOING, ECRANKED DOES NOT WARRANT OR MAKE ANY
      REPRESENTATION REGARDING USE, THE ABILITY TO USE, OR THE RESULT OF USE OF
      THE CONTENT IN TERMS OF ACCURACY, RELIABILITY, OR OTHERWISE. THE CONTENT
      MAY INCLUDE TECHNICAL INACCURACIES. ECRANKED MAY MAKE CHANGES OR
      IMPROVEMENTS TO THE CONTENT OR THE WEBSITE AT ANY TIME. ECRANKED MAKES NO
      WARRANTIES THAT YOUR USE OF THE CONTENT WILL NOT INFRINGE THE RIGHTS OF
      OTHERS AND ASSUMES NO LIABILITY OR RESPONSIBILITY FOR ERRORS OR OMISSIONS
      IN SUCH CONTENT.
      <h2>9. LIMITATION OF LIABILITY </h2>
      ECRANKED, ITS EMPLOYEES, AGENTS, OFFICERS AND DIRECTORS WILL NOT BE LIABLE
      FOR ANY DIRECT, INDIRECT, INCIDENTAL, PUNITIVE, CONSEQUENTIAL, SPECIAL,
      EXEMPLARY, OR OTHER DAMAGES, INCLUDING, WITHOUT LIMITATION, LOSS OF
      REVENUE OR INCOME, PAIN AND SUFFERING, EMOTIONAL DISTRESS, OR SIMILAR
      DAMAGES, OR DAMAGES RESULTING FROM ANY (I) ERRORS OR OMISSIONS IN CONTENT,
      (II) ANY UNAUTHORIZED ACCESS TO OR USE OF OUR SERVERS AND/OR ANY AND ALL
      PERSONAL INFORMATION AND/OR FINANCIAL INFORMATION STORED THEREIN, (III)
      ANY INTERRUPTION OR CESSATION OF TRANSMISSION TO OR FROM OUR WEBSITE, (IV)
      ANY BUGS, VIRUSES, TROJAN HORSES, OR THE LIKE, WHICH MAY BE TRANSMITTED TO
      OR THROUGH OUR WEBSITE BY ANY THIRD PARTY, OR (V) FOR ANY LOSS OR DAMAGE
      OF ANY KIND INCURRED AS A RESULT OF YOUR USE OF ANY CONTENT POSTED,
      EMAILED, TRANSMITTED, OR OTHERWISE MADE AVAILABLE VIA THE WEBSITE. THIS
      LIMITATION OF LIABILITY APPLIES REGARDLESS OF THE LEGAL THEORY GIVING RISE
      TO THE DAMAGES, AND EVEN IF ECRANKED HAS BEEN ADVISED OF THE POSSIBILITY
      OF SUCH DAMAGES. THE FOREGOING LIMITATION OF LIABILITY SHALL APPLY TO THE
      FULLEST EXTENT PERMITTED BY LAW IN THE APPLICABLE JURISDICTION. YOU
      SPECIFICALLY ACKNOWLEDGE THAT ECRANKED, ITS EMPLOYEES, AGENTS, OFFICERS
      AND DIRECTORS SHALL NOT BE LIABLE FOR USER CONTENT OR THE DEFAMATORY,
      OFFENSIVE, OR ILLEGAL CONDUCT OF ANY THIRD PARTY AND THAT THE RISK OF HARM
      OR DAMAGE FROM THE FOREGOING RESTS ENTIRELY WITH YOU.
      <h2>10. INDEMNITY</h2>
      YOU AGREE TO DEFEND, INDEMNIFY AND HOLD HARMLESS ECRANKED, ITS EMPLOYEES,
      AGENTS, OFFICERS AND DIRECTORS FROM AND AGAINST ANY AND ALL CLAIMS,
      DAMAGES, OBLIGATIONS, JUDGMENTS, LOSSES, LIABILITIES, COSTS OR DEBT,
      ATTORNEY'S FEES AND OTHER EXPENSES ARISING FROM: (I) YOUR USE OF AND
      ACCESS TO THE WEBSITE; (II) YOUR VIOLATION OF ANY THIRD PARTY RIGHT,
      INCLUDING WITHOUT LIMITATION ANY COPYRIGHT, PROPERTY, OR PRIVACY RIGHT; OR
      (III) ANY CLAIM THAT YOU DID NOT HAVE THE RIGHT TO PROVIDE ANY USER
      CONTENT OR THAT YOUR USER CONTENT CAUSED DAMAGE TO A THIRD PARTY. THIS
      DEFENSE AND INDEMNIFICATION OBLIGATION WILL SURVIVE THESE TERMS AND YOUR
      USE OF THE WEBSITE. IN SUCH A CASE, ECRANKED WILL PROVIDE YOU WITH WRITTEN
      NOTICE OF SUCH CLAIM, SUIT OR ACTION.
    </MainTextStyle>
  );
}
